// auto-generated
export function loadSvg(icon) {
	switch (icon) {
		case 'emoji:angry':
			return import(/* webpackChunkName: "icon-angry" */'./emoji/angry.js');
		case 'emoji:happy':
			return import(/* webpackChunkName: "icon-happy" */'./emoji/happy.js');
		case 'emoji:lol':
			return import(/* webpackChunkName: "icon-lol" */'./emoji/lol.js');
		case 'emoji:meh':
			return import(/* webpackChunkName: "icon-meh" */'./emoji/meh.js');
		case 'emoji:sad':
			return import(/* webpackChunkName: "icon-sad" */'./emoji/sad.js');
		case 'emoji:shout':
			return import(/* webpackChunkName: "icon-shout" */'./emoji/shout.js');
		case 'html-editor:accessibility-check':
			return import(/* webpackChunkName: "icon-accessibility-check" */'./html-editor/accessibility-check.js');
		case 'html-editor:align-center':
			return import(/* webpackChunkName: "icon-align-center" */'./html-editor/align-center.js');
		case 'html-editor:align-full':
			return import(/* webpackChunkName: "icon-align-full" */'./html-editor/align-full.js');
		case 'html-editor:align-left':
			return import(/* webpackChunkName: "icon-align-left" */'./html-editor/align-left.js');
		case 'html-editor:align-right':
			return import(/* webpackChunkName: "icon-align-right" */'./html-editor/align-right.js');
		case 'html-editor:bold':
			return import(/* webpackChunkName: "icon-bold" */'./html-editor/bold.js');
		case 'html-editor:cut':
			return import(/* webpackChunkName: "icon-cut" */'./html-editor/cut.js');
		case 'html-editor:direction-ltr':
			return import(/* webpackChunkName: "icon-direction-ltr" */'./html-editor/direction-ltr.js');
		case 'html-editor:direction-rtl':
			return import(/* webpackChunkName: "icon-direction-rtl" */'./html-editor/direction-rtl.js');
		case 'html-editor:equation-graphical-chemistry':
			return import(/* webpackChunkName: "icon-equation-graphical-chemistry" */'./html-editor/equation-graphical-chemistry.js');
		case 'html-editor:equation-graphical':
			return import(/* webpackChunkName: "icon-equation-graphical" */'./html-editor/equation-graphical.js');
		case 'html-editor:equation-latex':
			return import(/* webpackChunkName: "icon-equation-latex" */'./html-editor/equation-latex.js');
		case 'html-editor:equation-mathml':
			return import(/* webpackChunkName: "icon-equation-mathml" */'./html-editor/equation-mathml.js');
		case 'html-editor:image':
			return import(/* webpackChunkName: "icon-image" */'./html-editor/image.js');
		case 'html-editor:indent-decrease':
			return import(/* webpackChunkName: "icon-indent-decrease" */'./html-editor/indent-decrease.js');
		case 'html-editor:indent-increase':
			return import(/* webpackChunkName: "icon-indent-increase" */'./html-editor/indent-increase.js');
		case 'html-editor:insert-attributes':
			return import(/* webpackChunkName: "icon-insert-attributes" */'./html-editor/insert-attributes.js');
		case 'html-editor:insert-emoticon':
			return import(/* webpackChunkName: "icon-insert-emoticon" */'./html-editor/insert-emoticon.js');
		case 'html-editor:italic':
			return import(/* webpackChunkName: "icon-italic" */'./html-editor/italic.js');
		case 'html-editor:link':
			return import(/* webpackChunkName: "icon-link" */'./html-editor/link.js');
		case 'html-editor:list-bullet':
			return import(/* webpackChunkName: "icon-list-bullet" */'./html-editor/list-bullet.js');
		case 'html-editor:list-ordered':
			return import(/* webpackChunkName: "icon-list-ordered" */'./html-editor/list-ordered.js');
		case 'html-editor:media':
			return import(/* webpackChunkName: "icon-media" */'./html-editor/media.js');
		case 'html-editor:new-line':
			return import(/* webpackChunkName: "icon-new-line" */'./html-editor/new-line.js');
		case 'html-editor:paste':
			return import(/* webpackChunkName: "icon-paste" */'./html-editor/paste.js');
		case 'html-editor:source-editor':
			return import(/* webpackChunkName: "icon-source-editor" */'./html-editor/source-editor.js');
		case 'html-editor:spellcheck':
			return import(/* webpackChunkName: "icon-spellcheck" */'./html-editor/spellcheck.js');
		case 'html-editor:strikethrough':
			return import(/* webpackChunkName: "icon-strikethrough" */'./html-editor/strikethrough.js');
		case 'html-editor:subscript':
			return import(/* webpackChunkName: "icon-subscript" */'./html-editor/subscript.js');
		case 'html-editor:superscript':
			return import(/* webpackChunkName: "icon-superscript" */'./html-editor/superscript.js');
		case 'html-editor:symbol':
			return import(/* webpackChunkName: "icon-symbol" */'./html-editor/symbol.js');
		case 'html-editor:table-cell-merge':
			return import(/* webpackChunkName: "icon-table-cell-merge" */'./html-editor/table-cell-merge.js');
		case 'html-editor:table-cell-properties':
			return import(/* webpackChunkName: "icon-table-cell-properties" */'./html-editor/table-cell-properties.js');
		case 'html-editor:table-cell-split':
			return import(/* webpackChunkName: "icon-table-cell-split" */'./html-editor/table-cell-split.js');
		case 'html-editor:table-column-insert-after':
			return import(/* webpackChunkName: "icon-table-column-insert-after" */'./html-editor/table-column-insert-after.js');
		case 'html-editor:table-column-insert-before':
			return import(/* webpackChunkName: "icon-table-column-insert-before" */'./html-editor/table-column-insert-before.js');
		case 'html-editor:table-column-remove':
			return import(/* webpackChunkName: "icon-table-column-remove" */'./html-editor/table-column-remove.js');
		case 'html-editor:table-delete':
			return import(/* webpackChunkName: "icon-table-delete" */'./html-editor/table-delete.js');
		case 'html-editor:table-properties':
			return import(/* webpackChunkName: "icon-table-properties" */'./html-editor/table-properties.js');
		case 'html-editor:table-row-copy':
			return import(/* webpackChunkName: "icon-table-row-copy" */'./html-editor/table-row-copy.js');
		case 'html-editor:table-row-cut':
			return import(/* webpackChunkName: "icon-table-row-cut" */'./html-editor/table-row-cut.js');
		case 'html-editor:table-row-insert-after':
			return import(/* webpackChunkName: "icon-table-row-insert-after" */'./html-editor/table-row-insert-after.js');
		case 'html-editor:table-row-insert-before':
			return import(/* webpackChunkName: "icon-table-row-insert-before" */'./html-editor/table-row-insert-before.js');
		case 'html-editor:table-row-paste-above':
			return import(/* webpackChunkName: "icon-table-row-paste-above" */'./html-editor/table-row-paste-above.js');
		case 'html-editor:table-row-paste-below':
			return import(/* webpackChunkName: "icon-table-row-paste-below" */'./html-editor/table-row-paste-below.js');
		case 'html-editor:table-row-properties':
			return import(/* webpackChunkName: "icon-table-row-properties" */'./html-editor/table-row-properties.js');
		case 'html-editor:table-row-remove':
			return import(/* webpackChunkName: "icon-table-row-remove" */'./html-editor/table-row-remove.js');
		case 'html-editor:underline':
			return import(/* webpackChunkName: "icon-underline" */'./html-editor/underline.js');
		case 'tier1:accelerator':
			return import(/* webpackChunkName: "icon-accelerator" */'./tier1/accelerator.js');
		case 'tier1:access-special':
			return import(/* webpackChunkName: "icon-access-special" */'./tier1/access-special.js');
		case 'tier1:add-file':
			return import(/* webpackChunkName: "icon-add-file" */'./tier1/add-file.js');
		case 'tier1:add-message':
			return import(/* webpackChunkName: "icon-add-message" */'./tier1/add-message.js');
		case 'tier1:add-to-lor':
			return import(/* webpackChunkName: "icon-add-to-lor" */'./tier1/add-to-lor.js');
		case 'tier1:add-user':
			return import(/* webpackChunkName: "icon-add-user" */'./tier1/add-user.js');
		case 'tier1:add':
			return import(/* webpackChunkName: "icon-add" */'./tier1/add.js');
		case 'tier1:ai':
			return import(/* webpackChunkName: "icon-ai" */'./tier1/ai.js');
		case 'tier1:alarmbell':
			return import(/* webpackChunkName: "icon-alarmbell" */'./tier1/alarmbell.js');
		case 'tier1:alert':
			return import(/* webpackChunkName: "icon-alert" */'./tier1/alert.js');
		case 'tier1:arrow-collapse-small':
			return import(/* webpackChunkName: "icon-arrow-collapse-small" */'./tier1/arrow-collapse-small.js');
		case 'tier1:arrow-collapse':
			return import(/* webpackChunkName: "icon-arrow-collapse" */'./tier1/arrow-collapse.js');
		case 'tier1:arrow-expand-small':
			return import(/* webpackChunkName: "icon-arrow-expand-small" */'./tier1/arrow-expand-small.js');
		case 'tier1:arrow-expand':
			return import(/* webpackChunkName: "icon-arrow-expand" */'./tier1/arrow-expand.js');
		case 'tier1:arrow-thin-down':
			return import(/* webpackChunkName: "icon-arrow-thin-down" */'./tier1/arrow-thin-down.js');
		case 'tier1:arrow-thin-left':
			return import(/* webpackChunkName: "icon-arrow-thin-left" */'./tier1/arrow-thin-left.js');
		case 'tier1:arrow-thin-right':
			return import(/* webpackChunkName: "icon-arrow-thin-right" */'./tier1/arrow-thin-right.js');
		case 'tier1:arrow-thin-up':
			return import(/* webpackChunkName: "icon-arrow-thin-up" */'./tier1/arrow-thin-up.js');
		case 'tier1:arrow-toggle-down':
			return import(/* webpackChunkName: "icon-arrow-toggle-down" */'./tier1/arrow-toggle-down.js');
		case 'tier1:arrow-toggle-up':
			return import(/* webpackChunkName: "icon-arrow-toggle-up" */'./tier1/arrow-toggle-up.js');
		case 'tier1:assignments':
			return import(/* webpackChunkName: "icon-assignments" */'./tier1/assignments.js');
		case 'tier1:attach':
			return import(/* webpackChunkName: "icon-attach" */'./tier1/attach.js');
		case 'tier1:attendance':
			return import(/* webpackChunkName: "icon-attendance" */'./tier1/attendance.js');
		case 'tier1:awards':
			return import(/* webpackChunkName: "icon-awards" */'./tier1/awards.js');
		case 'tier1:binder':
			return import(/* webpackChunkName: "icon-binder" */'./tier1/binder.js');
		case 'tier1:blocked':
			return import(/* webpackChunkName: "icon-blocked" */'./tier1/blocked.js');
		case 'tier1:blog':
			return import(/* webpackChunkName: "icon-blog" */'./tier1/blog.js');
		case 'tier1:book-management':
			return import(/* webpackChunkName: "icon-book-management" */'./tier1/book-management.js');
		case 'tier1:bookmark-filled':
			return import(/* webpackChunkName: "icon-bookmark-filled" */'./tier1/bookmark-filled.js');
		case 'tier1:bookmark-hollow':
			return import(/* webpackChunkName: "icon-bookmark-hollow" */'./tier1/bookmark-hollow.js');
		case 'tier1:broken-link':
			return import(/* webpackChunkName: "icon-broken-link" */'./tier1/broken-link.js');
		case 'tier1:browser':
			return import(/* webpackChunkName: "icon-browser" */'./tier1/browser.js');
		case 'tier1:bullet':
			return import(/* webpackChunkName: "icon-bullet" */'./tier1/bullet.js');
		case 'tier1:bullseye':
			return import(/* webpackChunkName: "icon-bullseye" */'./tier1/bullseye.js');
		case 'tier1:calculate':
			return import(/* webpackChunkName: "icon-calculate" */'./tier1/calculate.js');
		case 'tier1:calendar':
			return import(/* webpackChunkName: "icon-calendar" */'./tier1/calendar.js');
		case 'tier1:change-file':
			return import(/* webpackChunkName: "icon-change-file" */'./tier1/change-file.js');
		case 'tier1:chat':
			return import(/* webpackChunkName: "icon-chat" */'./tier1/chat.js');
		case 'tier1:check-circle':
			return import(/* webpackChunkName: "icon-check-circle" */'./tier1/check-circle.js');
		case 'tier1:check-manual':
			return import(/* webpackChunkName: "icon-check-manual" */'./tier1/check-manual.js');
		case 'tier1:check-user':
			return import(/* webpackChunkName: "icon-check-user" */'./tier1/check-user.js');
		case 'tier1:check':
			return import(/* webpackChunkName: "icon-check" */'./tier1/check.js');
		case 'tier1:checklist':
			return import(/* webpackChunkName: "icon-checklist" */'./tier1/checklist.js');
		case 'tier1:chevron-down-medium':
			return import(/* webpackChunkName: "icon-chevron-down-medium" */'./tier1/chevron-down-medium.js');
		case 'tier1:chevron-down-small':
			return import(/* webpackChunkName: "icon-chevron-down-small" */'./tier1/chevron-down-small.js');
		case 'tier1:chevron-down':
			return import(/* webpackChunkName: "icon-chevron-down" */'./tier1/chevron-down.js');
		case 'tier1:chevron-left':
			return import(/* webpackChunkName: "icon-chevron-left" */'./tier1/chevron-left.js');
		case 'tier1:chevron-right':
			return import(/* webpackChunkName: "icon-chevron-right" */'./tier1/chevron-right.js');
		case 'tier1:chevron-up':
			return import(/* webpackChunkName: "icon-chevron-up" */'./tier1/chevron-up.js');
		case 'tier1:class':
			return import(/* webpackChunkName: "icon-class" */'./tier1/class.js');
		case 'tier1:classlist':
			return import(/* webpackChunkName: "icon-classlist" */'./tier1/classlist.js');
		case 'tier1:close-circle':
			return import(/* webpackChunkName: "icon-close-circle" */'./tier1/close-circle.js');
		case 'tier1:close-default':
			return import(/* webpackChunkName: "icon-close-default" */'./tier1/close-default.js');
		case 'tier1:close-large-thick':
			return import(/* webpackChunkName: "icon-close-large-thick" */'./tier1/close-large-thick.js');
		case 'tier1:close-large':
			return import(/* webpackChunkName: "icon-close-large" */'./tier1/close-large.js');
		case 'tier1:close-small':
			return import(/* webpackChunkName: "icon-close-small" */'./tier1/close-small.js');
		case 'tier1:comment-filled':
			return import(/* webpackChunkName: "icon-comment-filled" */'./tier1/comment-filled.js');
		case 'tier1:comment-hollow':
			return import(/* webpackChunkName: "icon-comment-hollow" */'./tier1/comment-hollow.js');
		case 'tier1:contacts':
			return import(/* webpackChunkName: "icon-contacts" */'./tier1/contacts.js');
		case 'tier1:copy':
			return import(/* webpackChunkName: "icon-copy" */'./tier1/copy.js');
		case 'tier1:course-tile-sort':
			return import(/* webpackChunkName: "icon-course-tile-sort" */'./tier1/course-tile-sort.js');
		case 'tier1:course':
			return import(/* webpackChunkName: "icon-course" */'./tier1/course.js');
		case 'tier1:coursebuilder':
			return import(/* webpackChunkName: "icon-coursebuilder" */'./tier1/coursebuilder.js');
		case 'tier1:delete':
			return import(/* webpackChunkName: "icon-delete" */'./tier1/delete.js');
		case 'tier1:disable':
			return import(/* webpackChunkName: "icon-disable" */'./tier1/disable.js');
		case 'tier1:discussions':
			return import(/* webpackChunkName: "icon-discussions" */'./tier1/discussions.js');
		case 'tier1:divider-solid':
			return import(/* webpackChunkName: "icon-divider-solid" */'./tier1/divider-solid.js');
		case 'tier1:dot':
			return import(/* webpackChunkName: "icon-dot" */'./tier1/dot.js');
		case 'tier1:download':
			return import(/* webpackChunkName: "icon-download" */'./tier1/download.js');
		case 'tier1:draft':
			return import(/* webpackChunkName: "icon-draft" */'./tier1/draft.js');
		case 'tier1:dragger':
			return import(/* webpackChunkName: "icon-dragger" */'./tier1/dragger.js');
		case 'tier1:edit-bulk':
			return import(/* webpackChunkName: "icon-edit-bulk" */'./tier1/edit-bulk.js');
		case 'tier1:edit':
			return import(/* webpackChunkName: "icon-edit" */'./tier1/edit.js');
		case 'tier1:email-read':
			return import(/* webpackChunkName: "icon-email-read" */'./tier1/email-read.js');
		case 'tier1:email':
			return import(/* webpackChunkName: "icon-email" */'./tier1/email.js');
		case 'tier1:enable':
			return import(/* webpackChunkName: "icon-enable" */'./tier1/enable.js');
		case 'tier1:enrollment':
			return import(/* webpackChunkName: "icon-enrollment" */'./tier1/enrollment.js');
		case 'tier1:eportfolio':
			return import(/* webpackChunkName: "icon-eportfolio" */'./tier1/eportfolio.js');
		case 'tier1:event-log':
			return import(/* webpackChunkName: "icon-event-log" */'./tier1/event-log.js');
		case 'tier1:exemption-add':
			return import(/* webpackChunkName: "icon-exemption-add" */'./tier1/exemption-add.js');
		case 'tier1:exemption-remove':
			return import(/* webpackChunkName: "icon-exemption-remove" */'./tier1/exemption-remove.js');
		case 'tier1:export':
			return import(/* webpackChunkName: "icon-export" */'./tier1/export.js');
		case 'tier1:external':
			return import(/* webpackChunkName: "icon-external" */'./tier1/external.js');
		case 'tier1:feed':
			return import(/* webpackChunkName: "icon-feed" */'./tier1/feed.js');
		case 'tier1:feedback':
			return import(/* webpackChunkName: "icon-feedback" */'./tier1/feedback.js');
		case 'tier1:file-archive':
			return import(/* webpackChunkName: "icon-file-archive" */'./tier1/file-archive.js');
		case 'tier1:file-audio':
			return import(/* webpackChunkName: "icon-file-audio" */'./tier1/file-audio.js');
		case 'tier1:file-document':
			return import(/* webpackChunkName: "icon-file-document" */'./tier1/file-document.js');
		case 'tier1:file-image':
			return import(/* webpackChunkName: "icon-file-image" */'./tier1/file-image.js');
		case 'tier1:file-presentation':
			return import(/* webpackChunkName: "icon-file-presentation" */'./tier1/file-presentation.js');
		case 'tier1:file-video':
			return import(/* webpackChunkName: "icon-file-video" */'./tier1/file-video.js');
		case 'tier1:filter':
			return import(/* webpackChunkName: "icon-filter" */'./tier1/filter.js');
		case 'tier1:flag-filled':
			return import(/* webpackChunkName: "icon-flag-filled" */'./tier1/flag-filled.js');
		case 'tier1:flag-hollow':
			return import(/* webpackChunkName: "icon-flag-hollow" */'./tier1/flag-hollow.js');
		case 'tier1:folder-up-level':
			return import(/* webpackChunkName: "icon-folder-up-level" */'./tier1/folder-up-level.js');
		case 'tier1:folder':
			return import(/* webpackChunkName: "icon-folder" */'./tier1/folder.js');
		case 'tier1:forms':
			return import(/* webpackChunkName: "icon-forms" */'./tier1/forms.js');
		case 'tier1:forward':
			return import(/* webpackChunkName: "icon-forward" */'./tier1/forward.js');
		case 'tier1:fullscreen':
			return import(/* webpackChunkName: "icon-fullscreen" */'./tier1/fullscreen.js');
		case 'tier1:game':
			return import(/* webpackChunkName: "icon-game" */'./tier1/game.js');
		case 'tier1:gear':
			return import(/* webpackChunkName: "icon-gear" */'./tier1/gear.js');
		case 'tier1:glossary':
			return import(/* webpackChunkName: "icon-glossary" */'./tier1/glossary.js');
		case 'tier1:google-drive':
			return import(/* webpackChunkName: "icon-google-drive" */'./tier1/google-drive.js');
		case 'tier1:grabber-small':
			return import(/* webpackChunkName: "icon-grabber-small" */'./tier1/grabber-small.js');
		case 'tier1:grabber':
			return import(/* webpackChunkName: "icon-grabber" */'./tier1/grabber.js');
		case 'tier1:grade-remove':
			return import(/* webpackChunkName: "icon-grade-remove" */'./tier1/grade-remove.js');
		case 'tier1:grade-visible':
			return import(/* webpackChunkName: "icon-grade-visible" */'./tier1/grade-visible.js');
		case 'tier1:grade':
			return import(/* webpackChunkName: "icon-grade" */'./tier1/grade.js');
		case 'tier1:group-locker':
			return import(/* webpackChunkName: "icon-group-locker" */'./tier1/group-locker.js');
		case 'tier1:group':
			return import(/* webpackChunkName: "icon-group" */'./tier1/group.js');
		case 'tier1:help':
			return import(/* webpackChunkName: "icon-help" */'./tier1/help.js');
		case 'tier1:history':
			return import(/* webpackChunkName: "icon-history" */'./tier1/history.js');
		case 'tier1:home':
			return import(/* webpackChunkName: "icon-home" */'./tier1/home.js');
		case 'tier1:import':
			return import(/* webpackChunkName: "icon-import" */'./tier1/import.js');
		case 'tier1:important':
			return import(/* webpackChunkName: "icon-important" */'./tier1/important.js');
		case 'tier1:insights-portal':
			return import(/* webpackChunkName: "icon-insights-portal" */'./tier1/insights-portal.js');
		case 'tier1:link':
			return import(/* webpackChunkName: "icon-link" */'./tier1/link.js');
		case 'tier1:list-view':
			return import(/* webpackChunkName: "icon-list-view" */'./tier1/list-view.js');
		case 'tier1:location':
			return import(/* webpackChunkName: "icon-location" */'./tier1/location.js');
		case 'tier1:locations':
			return import(/* webpackChunkName: "icon-locations" */'./tier1/locations.js');
		case 'tier1:lock-locked':
			return import(/* webpackChunkName: "icon-lock-locked" */'./tier1/lock-locked.js');
		case 'tier1:lock-unlock':
			return import(/* webpackChunkName: "icon-lock-unlock" */'./tier1/lock-unlock.js');
		case 'tier1:locker':
			return import(/* webpackChunkName: "icon-locker" */'./tier1/locker.js');
		case 'tier1:lor':
			return import(/* webpackChunkName: "icon-lor" */'./tier1/lor.js');
		case 'tier1:low-priority':
			return import(/* webpackChunkName: "icon-low-priority" */'./tier1/low-priority.js');
		case 'tier1:manage-dates-edit':
			return import(/* webpackChunkName: "icon-manage-dates-edit" */'./tier1/manage-dates-edit.js');
		case 'tier1:manage-dates-offset':
			return import(/* webpackChunkName: "icon-manage-dates-offset" */'./tier1/manage-dates-offset.js');
		case 'tier1:manage-dates':
			return import(/* webpackChunkName: "icon-manage-dates" */'./tier1/manage-dates.js');
		case 'tier1:manage-files':
			return import(/* webpackChunkName: "icon-manage-files" */'./tier1/manage-files.js');
		case 'tier1:manual-run':
			return import(/* webpackChunkName: "icon-manual-run" */'./tier1/manual-run.js');
		case 'tier1:menu-hamburger':
			return import(/* webpackChunkName: "icon-menu-hamburger" */'./tier1/menu-hamburger.js');
		case 'tier1:messages':
			return import(/* webpackChunkName: "icon-messages" */'./tier1/messages.js');
		case 'tier1:mic':
			return import(/* webpackChunkName: "icon-mic" */'./tier1/mic.js');
		case 'tier1:mobile':
			return import(/* webpackChunkName: "icon-mobile" */'./tier1/mobile.js');
		case 'tier1:more':
			return import(/* webpackChunkName: "icon-more" */'./tier1/more.js');
		case 'tier1:move-down':
			return import(/* webpackChunkName: "icon-move-down" */'./tier1/move-down.js');
		case 'tier1:move-to':
			return import(/* webpackChunkName: "icon-move-to" */'./tier1/move-to.js');
		case 'tier1:move-up':
			return import(/* webpackChunkName: "icon-move-up" */'./tier1/move-up.js');
		case 'tier1:my-computer':
			return import(/* webpackChunkName: "icon-my-computer" */'./tier1/my-computer.js');
		case 'tier1:navigate':
			return import(/* webpackChunkName: "icon-navigate" */'./tier1/navigate.js');
		case 'tier1:new-window':
			return import(/* webpackChunkName: "icon-new-window" */'./tier1/new-window.js');
		case 'tier1:news':
			return import(/* webpackChunkName: "icon-news" */'./tier1/news.js');
		case 'tier1:no-entry':
			return import(/* webpackChunkName: "icon-no-entry" */'./tier1/no-entry.js');
		case 'tier1:one-drive':
			return import(/* webpackChunkName: "icon-one-drive" */'./tier1/one-drive.js');
		case 'tier1:online-rooms':
			return import(/* webpackChunkName: "icon-online-rooms" */'./tier1/online-rooms.js');
		case 'tier1:online':
			return import(/* webpackChunkName: "icon-online" */'./tier1/online.js');
		case 'tier1:outcomes':
			return import(/* webpackChunkName: "icon-outcomes" */'./tier1/outcomes.js');
		case 'tier1:password':
			return import(/* webpackChunkName: "icon-password" */'./tier1/password.js');
		case 'tier1:pause':
			return import(/* webpackChunkName: "icon-pause" */'./tier1/pause.js');
		case 'tier1:pic':
			return import(/* webpackChunkName: "icon-pic" */'./tier1/pic.js');
		case 'tier1:pin-filled':
			return import(/* webpackChunkName: "icon-pin-filled" */'./tier1/pin-filled.js');
		case 'tier1:pin-hollow':
			return import(/* webpackChunkName: "icon-pin-hollow" */'./tier1/pin-hollow.js');
		case 'tier1:play':
			return import(/* webpackChunkName: "icon-play" */'./tier1/play.js');
		case 'tier1:plus-default':
			return import(/* webpackChunkName: "icon-plus-default" */'./tier1/plus-default.js');
		case 'tier1:plus-large-thick':
			return import(/* webpackChunkName: "icon-plus-large-thick" */'./tier1/plus-large-thick.js');
		case 'tier1:plus-large':
			return import(/* webpackChunkName: "icon-plus-large" */'./tier1/plus-large.js');
		case 'tier1:preview':
			return import(/* webpackChunkName: "icon-preview" */'./tier1/preview.js');
		case 'tier1:print':
			return import(/* webpackChunkName: "icon-print" */'./tier1/print.js');
		case 'tier1:profile-default':
			return import(/* webpackChunkName: "icon-profile-default" */'./tier1/profile-default.js');
		case 'tier1:profile-pic':
			return import(/* webpackChunkName: "icon-profile-pic" */'./tier1/profile-pic.js');
		case 'tier1:publish-to-lor':
			return import(/* webpackChunkName: "icon-publish-to-lor" */'./tier1/publish-to-lor.js');
		case 'tier1:quicklink':
			return import(/* webpackChunkName: "icon-quicklink" */'./tier1/quicklink.js');
		case 'tier1:quizzing':
			return import(/* webpackChunkName: "icon-quizzing" */'./tier1/quizzing.js');
		case 'tier1:read-unread':
			return import(/* webpackChunkName: "icon-read-unread" */'./tier1/read-unread.js');
		case 'tier1:read':
			return import(/* webpackChunkName: "icon-read" */'./tier1/read.js');
		case 'tier1:reading':
			return import(/* webpackChunkName: "icon-reading" */'./tier1/reading.js');
		case 'tier1:redo':
			return import(/* webpackChunkName: "icon-redo" */'./tier1/redo.js');
		case 'tier1:reflection':
			return import(/* webpackChunkName: "icon-reflection" */'./tier1/reflection.js');
		case 'tier1:refresh':
			return import(/* webpackChunkName: "icon-refresh" */'./tier1/refresh.js');
		case 'tier1:release-conditions':
			return import(/* webpackChunkName: "icon-release-conditions" */'./tier1/release-conditions.js');
		case 'tier1:remove-user':
			return import(/* webpackChunkName: "icon-remove-user" */'./tier1/remove-user.js');
		case 'tier1:reorder':
			return import(/* webpackChunkName: "icon-reorder" */'./tier1/reorder.js');
		case 'tier1:repeat':
			return import(/* webpackChunkName: "icon-repeat" */'./tier1/repeat.js');
		case 'tier1:replied':
			return import(/* webpackChunkName: "icon-replied" */'./tier1/replied.js');
		case 'tier1:reply':
			return import(/* webpackChunkName: "icon-reply" */'./tier1/reply.js');
		case 'tier1:reporting':
			return import(/* webpackChunkName: "icon-reporting" */'./tier1/reporting.js');
		case 'tier1:reports':
			return import(/* webpackChunkName: "icon-reports" */'./tier1/reports.js');
		case 'tier1:resize-left':
			return import(/* webpackChunkName: "icon-resize-left" */'./tier1/resize-left.js');
		case 'tier1:resize-right':
			return import(/* webpackChunkName: "icon-resize-right" */'./tier1/resize-right.js');
		case 'tier1:reverse-order':
			return import(/* webpackChunkName: "icon-reverse-order" */'./tier1/reverse-order.js');
		case 'tier1:role-switch':
			return import(/* webpackChunkName: "icon-role-switch" */'./tier1/role-switch.js');
		case 'tier1:rss':
			return import(/* webpackChunkName: "icon-rss" */'./tier1/rss.js');
		case 'tier1:rubric-graded':
			return import(/* webpackChunkName: "icon-rubric-graded" */'./tier1/rubric-graded.js');
		case 'tier1:rubric':
			return import(/* webpackChunkName: "icon-rubric" */'./tier1/rubric.js');
		case 'tier1:save':
			return import(/* webpackChunkName: "icon-save" */'./tier1/save.js');
		case 'tier1:scorm':
			return import(/* webpackChunkName: "icon-scorm" */'./tier1/scorm.js');
		case 'tier1:search':
			return import(/* webpackChunkName: "icon-search" */'./tier1/search.js');
		case 'tier1:seating':
			return import(/* webpackChunkName: "icon-seating" */'./tier1/seating.js');
		case 'tier1:self-assessment':
			return import(/* webpackChunkName: "icon-self-assessment" */'./tier1/self-assessment.js');
		case 'tier1:send':
			return import(/* webpackChunkName: "icon-send" */'./tier1/send.js');
		case 'tier1:share-hollow':
			return import(/* webpackChunkName: "icon-share-hollow" */'./tier1/share-hollow.js');
		case 'tier1:share-parent-filled':
			return import(/* webpackChunkName: "icon-share-parent-filled" */'./tier1/share-parent-filled.js');
		case 'tier1:share-parent-hollow':
			return import(/* webpackChunkName: "icon-share-parent-hollow" */'./tier1/share-parent-hollow.js');
		case 'tier1:share':
			return import(/* webpackChunkName: "icon-share" */'./tier1/share.js');
		case 'tier1:smallscreen':
			return import(/* webpackChunkName: "icon-smallscreen" */'./tier1/smallscreen.js');
		case 'tier1:sort-type':
			return import(/* webpackChunkName: "icon-sort-type" */'./tier1/sort-type.js');
		case 'tier1:spellcheck':
			return import(/* webpackChunkName: "icon-spellcheck" */'./tier1/spellcheck.js');
		case 'tier1:style':
			return import(/* webpackChunkName: "icon-style" */'./tier1/style.js');
		case 'tier1:subscribe-filled':
			return import(/* webpackChunkName: "icon-subscribe-filled" */'./tier1/subscribe-filled.js');
		case 'tier1:subscribe-hollow':
			return import(/* webpackChunkName: "icon-subscribe-hollow" */'./tier1/subscribe-hollow.js');
		case 'tier1:support':
			return import(/* webpackChunkName: "icon-support" */'./tier1/support.js');
		case 'tier1:surveys':
			return import(/* webpackChunkName: "icon-surveys" */'./tier1/surveys.js');
		case 'tier1:syllabus':
			return import(/* webpackChunkName: "icon-syllabus" */'./tier1/syllabus.js');
		case 'tier1:table-of-contents':
			return import(/* webpackChunkName: "icon-table-of-contents" */'./tier1/table-of-contents.js');
		case 'tier1:tag-hollow':
			return import(/* webpackChunkName: "icon-tag-hollow" */'./tier1/tag-hollow.js');
		case 'tier1:tag':
			return import(/* webpackChunkName: "icon-tag" */'./tier1/tag.js');
		case 'tier1:thumbs-down':
			return import(/* webpackChunkName: "icon-thumbs-down" */'./tier1/thumbs-down.js');
		case 'tier1:thumbs-up':
			return import(/* webpackChunkName: "icon-thumbs-up" */'./tier1/thumbs-up.js');
		case 'tier1:tile-view':
			return import(/* webpackChunkName: "icon-tile-view" */'./tier1/tile-view.js');
		case 'tier1:time':
			return import(/* webpackChunkName: "icon-time" */'./tier1/time.js');
		case 'tier1:tools':
			return import(/* webpackChunkName: "icon-tools" */'./tier1/tools.js');
		case 'tier1:topic-last':
			return import(/* webpackChunkName: "icon-topic-last" */'./tier1/topic-last.js');
		case 'tier1:turnitin':
			return import(/* webpackChunkName: "icon-turnitin" */'./tier1/turnitin.js');
		case 'tier1:unapproved':
			return import(/* webpackChunkName: "icon-unapproved" */'./tier1/unapproved.js');
		case 'tier1:undo':
			return import(/* webpackChunkName: "icon-undo" */'./tier1/undo.js');
		case 'tier1:unsaved':
			return import(/* webpackChunkName: "icon-unsaved" */'./tier1/unsaved.js');
		case 'tier1:upload':
			return import(/* webpackChunkName: "icon-upload" */'./tier1/upload.js');
		case 'tier1:user-competencies':
			return import(/* webpackChunkName: "icon-user-competencies" */'./tier1/user-competencies.js');
		case 'tier1:user-progress':
			return import(/* webpackChunkName: "icon-user-progress" */'./tier1/user-progress.js');
		case 'tier1:video-assignment':
			return import(/* webpackChunkName: "icon-video-assignment" */'./tier1/video-assignment.js');
		case 'tier1:virtual-classroom':
			return import(/* webpackChunkName: "icon-virtual-classroom" */'./tier1/virtual-classroom.js');
		case 'tier1:visibility-conditional':
			return import(/* webpackChunkName: "icon-visibility-conditional" */'./tier1/visibility-conditional.js');
		case 'tier1:visibility-hide':
			return import(/* webpackChunkName: "icon-visibility-hide" */'./tier1/visibility-hide.js');
		case 'tier1:visibility-show':
			return import(/* webpackChunkName: "icon-visibility-show" */'./tier1/visibility-show.js');
		case 'tier1:volume-muted':
			return import(/* webpackChunkName: "icon-volume-muted" */'./tier1/volume-muted.js');
		case 'tier1:volume':
			return import(/* webpackChunkName: "icon-volume" */'./tier1/volume.js');
		case 'tier1:widgets':
			return import(/* webpackChunkName: "icon-widgets" */'./tier1/widgets.js');
		case 'tier1:wizard':
			return import(/* webpackChunkName: "icon-wizard" */'./tier1/wizard.js');
		case 'tier1:zoom-in':
			return import(/* webpackChunkName: "icon-zoom-in" */'./tier1/zoom-in.js');
		case 'tier1:zoom-out':
			return import(/* webpackChunkName: "icon-zoom-out" */'./tier1/zoom-out.js');
		case 'tier2:accelerator':
			return import(/* webpackChunkName: "icon-accelerator" */'./tier2/accelerator.js');
		case 'tier2:add-file':
			return import(/* webpackChunkName: "icon-add-file" */'./tier2/add-file.js');
		case 'tier2:add-message':
			return import(/* webpackChunkName: "icon-add-message" */'./tier2/add-message.js');
		case 'tier2:add-to-lor':
			return import(/* webpackChunkName: "icon-add-to-lor" */'./tier2/add-to-lor.js');
		case 'tier2:add-user':
			return import(/* webpackChunkName: "icon-add-user" */'./tier2/add-user.js');
		case 'tier2:add':
			return import(/* webpackChunkName: "icon-add" */'./tier2/add.js');
		case 'tier2:ai':
			return import(/* webpackChunkName: "icon-ai" */'./tier2/ai.js');
		case 'tier2:alarmbell':
			return import(/* webpackChunkName: "icon-alarmbell" */'./tier2/alarmbell.js');
		case 'tier2:alert':
			return import(/* webpackChunkName: "icon-alert" */'./tier2/alert.js');
		case 'tier2:arrow-collapse':
			return import(/* webpackChunkName: "icon-arrow-collapse" */'./tier2/arrow-collapse.js');
		case 'tier2:assignments':
			return import(/* webpackChunkName: "icon-assignments" */'./tier2/assignments.js');
		case 'tier2:attach':
			return import(/* webpackChunkName: "icon-attach" */'./tier2/attach.js');
		case 'tier2:attendance':
			return import(/* webpackChunkName: "icon-attendance" */'./tier2/attendance.js');
		case 'tier2:awards':
			return import(/* webpackChunkName: "icon-awards" */'./tier2/awards.js');
		case 'tier2:binder':
			return import(/* webpackChunkName: "icon-binder" */'./tier2/binder.js');
		case 'tier2:blocked':
			return import(/* webpackChunkName: "icon-blocked" */'./tier2/blocked.js');
		case 'tier2:blog':
			return import(/* webpackChunkName: "icon-blog" */'./tier2/blog.js');
		case 'tier2:book-management':
			return import(/* webpackChunkName: "icon-book-management" */'./tier2/book-management.js');
		case 'tier2:bookmark-filled':
			return import(/* webpackChunkName: "icon-bookmark-filled" */'./tier2/bookmark-filled.js');
		case 'tier2:bookmark-hollow':
			return import(/* webpackChunkName: "icon-bookmark-hollow" */'./tier2/bookmark-hollow.js');
		case 'tier2:broken-link':
			return import(/* webpackChunkName: "icon-broken-link" */'./tier2/broken-link.js');
		case 'tier2:browser':
			return import(/* webpackChunkName: "icon-browser" */'./tier2/browser.js');
		case 'tier2:bullseye':
			return import(/* webpackChunkName: "icon-bullseye" */'./tier2/bullseye.js');
		case 'tier2:calculate':
			return import(/* webpackChunkName: "icon-calculate" */'./tier2/calculate.js');
		case 'tier2:calendar':
			return import(/* webpackChunkName: "icon-calendar" */'./tier2/calendar.js');
		case 'tier2:capture':
			return import(/* webpackChunkName: "icon-capture" */'./tier2/capture.js');
		case 'tier2:change-file':
			return import(/* webpackChunkName: "icon-change-file" */'./tier2/change-file.js');
		case 'tier2:chat':
			return import(/* webpackChunkName: "icon-chat" */'./tier2/chat.js');
		case 'tier2:check-box-unchecked':
			return import(/* webpackChunkName: "icon-check-box-unchecked" */'./tier2/check-box-unchecked.js');
		case 'tier2:check-box':
			return import(/* webpackChunkName: "icon-check-box" */'./tier2/check-box.js');
		case 'tier2:check-circle':
			return import(/* webpackChunkName: "icon-check-circle" */'./tier2/check-circle.js');
		case 'tier2:check':
			return import(/* webpackChunkName: "icon-check" */'./tier2/check.js');
		case 'tier2:checklist':
			return import(/* webpackChunkName: "icon-checklist" */'./tier2/checklist.js');
		case 'tier2:chevron-down':
			return import(/* webpackChunkName: "icon-chevron-down" */'./tier2/chevron-down.js');
		case 'tier2:chevron-left':
			return import(/* webpackChunkName: "icon-chevron-left" */'./tier2/chevron-left.js');
		case 'tier2:chevron-right':
			return import(/* webpackChunkName: "icon-chevron-right" */'./tier2/chevron-right.js');
		case 'tier2:chevron-up':
			return import(/* webpackChunkName: "icon-chevron-up" */'./tier2/chevron-up.js');
		case 'tier2:classes':
			return import(/* webpackChunkName: "icon-classes" */'./tier2/classes.js');
		case 'tier2:classlist':
			return import(/* webpackChunkName: "icon-classlist" */'./tier2/classlist.js');
		case 'tier2:contacts':
			return import(/* webpackChunkName: "icon-contacts" */'./tier2/contacts.js');
		case 'tier2:content':
			return import(/* webpackChunkName: "icon-content" */'./tier2/content.js');
		case 'tier2:copy':
			return import(/* webpackChunkName: "icon-copy" */'./tier2/copy.js');
		case 'tier2:course-tile-sort':
			return import(/* webpackChunkName: "icon-course-tile-sort" */'./tier2/course-tile-sort.js');
		case 'tier2:coursebuilder':
			return import(/* webpackChunkName: "icon-coursebuilder" */'./tier2/coursebuilder.js');
		case 'tier2:delete':
			return import(/* webpackChunkName: "icon-delete" */'./tier2/delete.js');
		case 'tier2:discussions':
			return import(/* webpackChunkName: "icon-discussions" */'./tier2/discussions.js');
		case 'tier2:divider-big':
			return import(/* webpackChunkName: "icon-divider-big" */'./tier2/divider-big.js');
		case 'tier2:divider':
			return import(/* webpackChunkName: "icon-divider" */'./tier2/divider.js');
		case 'tier2:dot':
			return import(/* webpackChunkName: "icon-dot" */'./tier2/dot.js');
		case 'tier2:download':
			return import(/* webpackChunkName: "icon-download" */'./tier2/download.js');
		case 'tier2:draft':
			return import(/* webpackChunkName: "icon-draft" */'./tier2/draft.js');
		case 'tier2:edit-not-editable':
			return import(/* webpackChunkName: "icon-edit-not-editable" */'./tier2/edit-not-editable.js');
		case 'tier2:edit':
			return import(/* webpackChunkName: "icon-edit" */'./tier2/edit.js');
		case 'tier2:email-open':
			return import(/* webpackChunkName: "icon-email-open" */'./tier2/email-open.js');
		case 'tier2:email':
			return import(/* webpackChunkName: "icon-email" */'./tier2/email.js');
		case 'tier2:eportfolio':
			return import(/* webpackChunkName: "icon-eportfolio" */'./tier2/eportfolio.js');
		case 'tier2:evaluate-all':
			return import(/* webpackChunkName: "icon-evaluate-all" */'./tier2/evaluate-all.js');
		case 'tier2:external':
			return import(/* webpackChunkName: "icon-external" */'./tier2/external.js');
		case 'tier2:feedback':
			return import(/* webpackChunkName: "icon-feedback" */'./tier2/feedback.js');
		case 'tier2:file-archive':
			return import(/* webpackChunkName: "icon-file-archive" */'./tier2/file-archive.js');
		case 'tier2:file-audio':
			return import(/* webpackChunkName: "icon-file-audio" */'./tier2/file-audio.js');
		case 'tier2:file-document':
			return import(/* webpackChunkName: "icon-file-document" */'./tier2/file-document.js');
		case 'tier2:file-image':
			return import(/* webpackChunkName: "icon-file-image" */'./tier2/file-image.js');
		case 'tier2:file-presentation':
			return import(/* webpackChunkName: "icon-file-presentation" */'./tier2/file-presentation.js');
		case 'tier2:file-video':
			return import(/* webpackChunkName: "icon-file-video" */'./tier2/file-video.js');
		case 'tier2:filter':
			return import(/* webpackChunkName: "icon-filter" */'./tier2/filter.js');
		case 'tier2:flag-fill':
			return import(/* webpackChunkName: "icon-flag-fill" */'./tier2/flag-fill.js');
		case 'tier2:flag-hollow':
			return import(/* webpackChunkName: "icon-flag-hollow" */'./tier2/flag-hollow.js');
		case 'tier2:folder':
			return import(/* webpackChunkName: "icon-folder" */'./tier2/folder.js');
		case 'tier2:forms':
			return import(/* webpackChunkName: "icon-forms" */'./tier2/forms.js');
		case 'tier2:fullscreen':
			return import(/* webpackChunkName: "icon-fullscreen" */'./tier2/fullscreen.js');
		case 'tier2:game':
			return import(/* webpackChunkName: "icon-game" */'./tier2/game.js');
		case 'tier2:gear':
			return import(/* webpackChunkName: "icon-gear" */'./tier2/gear.js');
		case 'tier2:glossary':
			return import(/* webpackChunkName: "icon-glossary" */'./tier2/glossary.js');
		case 'tier2:google-drive':
			return import(/* webpackChunkName: "icon-google-drive" */'./tier2/google-drive.js');
		case 'tier2:grade':
			return import(/* webpackChunkName: "icon-grade" */'./tier2/grade.js');
		case 'tier2:help':
			return import(/* webpackChunkName: "icon-help" */'./tier2/help.js');
		case 'tier2:history':
			return import(/* webpackChunkName: "icon-history" */'./tier2/history.js');
		case 'tier2:home':
			return import(/* webpackChunkName: "icon-home" */'./tier2/home.js');
		case 'tier2:insights-portal':
			return import(/* webpackChunkName: "icon-insights-portal" */'./tier2/insights-portal.js');
		case 'tier2:link':
			return import(/* webpackChunkName: "icon-link" */'./tier2/link.js');
		case 'tier2:location':
			return import(/* webpackChunkName: "icon-location" */'./tier2/location.js');
		case 'tier2:locations':
			return import(/* webpackChunkName: "icon-locations" */'./tier2/locations.js');
		case 'tier2:lock-unlocked':
			return import(/* webpackChunkName: "icon-lock-unlocked" */'./tier2/lock-unlocked.js');
		case 'tier2:lock':
			return import(/* webpackChunkName: "icon-lock" */'./tier2/lock.js');
		case 'tier2:locker':
			return import(/* webpackChunkName: "icon-locker" */'./tier2/locker.js');
		case 'tier2:lor':
			return import(/* webpackChunkName: "icon-lor" */'./tier2/lor.js');
		case 'tier2:manage-dates':
			return import(/* webpackChunkName: "icon-manage-dates" */'./tier2/manage-dates.js');
		case 'tier2:manage-files':
			return import(/* webpackChunkName: "icon-manage-files" */'./tier2/manage-files.js');
		case 'tier2:media':
			return import(/* webpackChunkName: "icon-media" */'./tier2/media.js');
		case 'tier2:menu-hamburger':
			return import(/* webpackChunkName: "icon-menu-hamburger" */'./tier2/menu-hamburger.js');
		case 'tier2:merge':
			return import(/* webpackChunkName: "icon-merge" */'./tier2/merge.js');
		case 'tier2:message-new':
			return import(/* webpackChunkName: "icon-message-new" */'./tier2/message-new.js');
		case 'tier2:messages':
			return import(/* webpackChunkName: "icon-messages" */'./tier2/messages.js');
		case 'tier2:mic':
			return import(/* webpackChunkName: "icon-mic" */'./tier2/mic.js');
		case 'tier2:move-down':
			return import(/* webpackChunkName: "icon-move-down" */'./tier2/move-down.js');
		case 'tier2:move-to':
			return import(/* webpackChunkName: "icon-move-to" */'./tier2/move-to.js');
		case 'tier2:move-up':
			return import(/* webpackChunkName: "icon-move-up" */'./tier2/move-up.js');
		case 'tier2:navigate':
			return import(/* webpackChunkName: "icon-navigate" */'./tier2/navigate.js');
		case 'tier2:news':
			return import(/* webpackChunkName: "icon-news" */'./tier2/news.js');
		case 'tier2:one-drive':
			return import(/* webpackChunkName: "icon-one-drive" */'./tier2/one-drive.js');
		case 'tier2:online-rooms':
			return import(/* webpackChunkName: "icon-online-rooms" */'./tier2/online-rooms.js');
		case 'tier2:online':
			return import(/* webpackChunkName: "icon-online" */'./tier2/online.js');
		case 'tier2:outcomes':
			return import(/* webpackChunkName: "icon-outcomes" */'./tier2/outcomes.js');
		case 'tier2:password':
			return import(/* webpackChunkName: "icon-password" */'./tier2/password.js');
		case 'tier2:pic':
			return import(/* webpackChunkName: "icon-pic" */'./tier2/pic.js');
		case 'tier2:pin-filled':
			return import(/* webpackChunkName: "icon-pin-filled" */'./tier2/pin-filled.js');
		case 'tier2:pin-hollow':
			return import(/* webpackChunkName: "icon-pin-hollow" */'./tier2/pin-hollow.js');
		case 'tier2:preview':
			return import(/* webpackChunkName: "icon-preview" */'./tier2/preview.js');
		case 'tier2:print':
			return import(/* webpackChunkName: "icon-print" */'./tier2/print.js');
		case 'tier2:profile-default':
			return import(/* webpackChunkName: "icon-profile-default" */'./tier2/profile-default.js');
		case 'tier2:profile-pic':
			return import(/* webpackChunkName: "icon-profile-pic" */'./tier2/profile-pic.js');
		case 'tier2:project':
			return import(/* webpackChunkName: "icon-project" */'./tier2/project.js');
		case 'tier2:publish-all':
			return import(/* webpackChunkName: "icon-publish-all" */'./tier2/publish-all.js');
		case 'tier2:publish-to-lor':
			return import(/* webpackChunkName: "icon-publish-to-lor" */'./tier2/publish-to-lor.js');
		case 'tier2:quicklink':
			return import(/* webpackChunkName: "icon-quicklink" */'./tier2/quicklink.js');
		case 'tier2:quiz-submissions':
			return import(/* webpackChunkName: "icon-quiz-submissions" */'./tier2/quiz-submissions.js');
		case 'tier2:quizzing':
			return import(/* webpackChunkName: "icon-quizzing" */'./tier2/quizzing.js');
		case 'tier2:read-unread':
			return import(/* webpackChunkName: "icon-read-unread" */'./tier2/read-unread.js');
		case 'tier2:read':
			return import(/* webpackChunkName: "icon-read" */'./tier2/read.js');
		case 'tier2:reading':
			return import(/* webpackChunkName: "icon-reading" */'./tier2/reading.js');
		case 'tier2:reflection':
			return import(/* webpackChunkName: "icon-reflection" */'./tier2/reflection.js');
		case 'tier2:refresh':
			return import(/* webpackChunkName: "icon-refresh" */'./tier2/refresh.js');
		case 'tier2:release-conditions':
			return import(/* webpackChunkName: "icon-release-conditions" */'./tier2/release-conditions.js');
		case 'tier2:remove-user':
			return import(/* webpackChunkName: "icon-remove-user" */'./tier2/remove-user.js');
		case 'tier2:reorder':
			return import(/* webpackChunkName: "icon-reorder" */'./tier2/reorder.js');
		case 'tier2:reply-all':
			return import(/* webpackChunkName: "icon-reply-all" */'./tier2/reply-all.js');
		case 'tier2:reply':
			return import(/* webpackChunkName: "icon-reply" */'./tier2/reply.js');
		case 'tier2:reporting':
			return import(/* webpackChunkName: "icon-reporting" */'./tier2/reporting.js');
		case 'tier2:rss':
			return import(/* webpackChunkName: "icon-rss" */'./tier2/rss.js');
		case 'tier2:rubrics':
			return import(/* webpackChunkName: "icon-rubrics" */'./tier2/rubrics.js');
		case 'tier2:save':
			return import(/* webpackChunkName: "icon-save" */'./tier2/save.js');
		case 'tier2:scorm':
			return import(/* webpackChunkName: "icon-scorm" */'./tier2/scorm.js');
		case 'tier2:search':
			return import(/* webpackChunkName: "icon-search" */'./tier2/search.js');
		case 'tier2:seating':
			return import(/* webpackChunkName: "icon-seating" */'./tier2/seating.js');
		case 'tier2:self-assessment':
			return import(/* webpackChunkName: "icon-self-assessment" */'./tier2/self-assessment.js');
		case 'tier2:send':
			return import(/* webpackChunkName: "icon-send" */'./tier2/send.js');
		case 'tier2:share':
			return import(/* webpackChunkName: "icon-share" */'./tier2/share.js');
		case 'tier2:smallscreen':
			return import(/* webpackChunkName: "icon-smallscreen" */'./tier2/smallscreen.js');
		case 'tier2:style':
			return import(/* webpackChunkName: "icon-style" */'./tier2/style.js');
		case 'tier2:subscribe-filled':
			return import(/* webpackChunkName: "icon-subscribe-filled" */'./tier2/subscribe-filled.js');
		case 'tier2:subscribe-hollow':
			return import(/* webpackChunkName: "icon-subscribe-hollow" */'./tier2/subscribe-hollow.js');
		case 'tier2:surveys':
			return import(/* webpackChunkName: "icon-surveys" */'./tier2/surveys.js');
		case 'tier2:syllabus':
			return import(/* webpackChunkName: "icon-syllabus" */'./tier2/syllabus.js');
		case 'tier2:table-of-contents':
			return import(/* webpackChunkName: "icon-table-of-contents" */'./tier2/table-of-contents.js');
		case 'tier2:tag':
			return import(/* webpackChunkName: "icon-tag" */'./tier2/tag.js');
		case 'tier2:time':
			return import(/* webpackChunkName: "icon-time" */'./tier2/time.js');
		case 'tier2:tools':
			return import(/* webpackChunkName: "icon-tools" */'./tier2/tools.js');
		case 'tier2:topic-last':
			return import(/* webpackChunkName: "icon-topic-last" */'./tier2/topic-last.js');
		case 'tier2:unapproved':
			return import(/* webpackChunkName: "icon-unapproved" */'./tier2/unapproved.js');
		case 'tier2:undo':
			return import(/* webpackChunkName: "icon-undo" */'./tier2/undo.js');
		case 'tier2:unsaved':
			return import(/* webpackChunkName: "icon-unsaved" */'./tier2/unsaved.js');
		case 'tier2:upload':
			return import(/* webpackChunkName: "icon-upload" */'./tier2/upload.js');
		case 'tier2:user-competencies':
			return import(/* webpackChunkName: "icon-user-competencies" */'./tier2/user-competencies.js');
		case 'tier2:user-progress':
			return import(/* webpackChunkName: "icon-user-progress" */'./tier2/user-progress.js');
		case 'tier2:validate':
			return import(/* webpackChunkName: "icon-validate" */'./tier2/validate.js');
		case 'tier2:video-assignment':
			return import(/* webpackChunkName: "icon-video-assignment" */'./tier2/video-assignment.js');
		case 'tier2:view-submission-list':
			return import(/* webpackChunkName: "icon-view-submission-list" */'./tier2/view-submission-list.js');
		case 'tier2:viewed-notviewed':
			return import(/* webpackChunkName: "icon-viewed-notviewed" */'./tier2/viewed-notviewed.js');
		case 'tier2:virtual-classroom':
			return import(/* webpackChunkName: "icon-virtual-classroom" */'./tier2/virtual-classroom.js');
		case 'tier2:visibility-hide':
			return import(/* webpackChunkName: "icon-visibility-hide" */'./tier2/visibility-hide.js');
		case 'tier2:visibility-show':
			return import(/* webpackChunkName: "icon-visibility-show" */'./tier2/visibility-show.js');
		case 'tier2:volume-muted':
			return import(/* webpackChunkName: "icon-volume-muted" */'./tier2/volume-muted.js');
		case 'tier2:volume':
			return import(/* webpackChunkName: "icon-volume" */'./tier2/volume.js');
		case 'tier2:wizard':
			return import(/* webpackChunkName: "icon-wizard" */'./tier2/wizard.js');
		case 'tier3:ai':
			return import(/* webpackChunkName: "icon-ai" */'./tier3/ai.js');
		case 'tier3:alert':
			return import(/* webpackChunkName: "icon-alert" */'./tier3/alert.js');
		case 'tier3:assignments':
			return import(/* webpackChunkName: "icon-assignments" */'./tier3/assignments.js');
		case 'tier3:bookmark':
			return import(/* webpackChunkName: "icon-bookmark" */'./tier3/bookmark.js');
		case 'tier3:bullseye':
			return import(/* webpackChunkName: "icon-bullseye" */'./tier3/bullseye.js');
		case 'tier3:calendar':
			return import(/* webpackChunkName: "icon-calendar" */'./tier3/calendar.js');
		case 'tier3:chat':
			return import(/* webpackChunkName: "icon-chat" */'./tier3/chat.js');
		case 'tier3:check-circle':
			return import(/* webpackChunkName: "icon-check-circle" */'./tier3/check-circle.js');
		case 'tier3:chevron-down':
			return import(/* webpackChunkName: "icon-chevron-down" */'./tier3/chevron-down.js');
		case 'tier3:chevron-left-circle':
			return import(/* webpackChunkName: "icon-chevron-left-circle" */'./tier3/chevron-left-circle.js');
		case 'tier3:chevron-left':
			return import(/* webpackChunkName: "icon-chevron-left" */'./tier3/chevron-left.js');
		case 'tier3:chevron-right-circle':
			return import(/* webpackChunkName: "icon-chevron-right-circle" */'./tier3/chevron-right-circle.js');
		case 'tier3:chevron-right':
			return import(/* webpackChunkName: "icon-chevron-right" */'./tier3/chevron-right.js');
		case 'tier3:chevron-up':
			return import(/* webpackChunkName: "icon-chevron-up" */'./tier3/chevron-up.js');
		case 'tier3:classes':
			return import(/* webpackChunkName: "icon-classes" */'./tier3/classes.js');
		case 'tier3:close-thick':
			return import(/* webpackChunkName: "icon-close-thick" */'./tier3/close-thick.js');
		case 'tier3:close':
			return import(/* webpackChunkName: "icon-close" */'./tier3/close.js');
		case 'tier3:copy':
			return import(/* webpackChunkName: "icon-copy" */'./tier3/copy.js');
		case 'tier3:course-progress-complete':
			return import(/* webpackChunkName: "icon-course-progress-complete" */'./tier3/course-progress-complete.js');
		case 'tier3:course-progress-in-progress':
			return import(/* webpackChunkName: "icon-course-progress-in-progress" */'./tier3/course-progress-in-progress.js');
		case 'tier3:course-progress-not-started':
			return import(/* webpackChunkName: "icon-course-progress-not-started" */'./tier3/course-progress-not-started.js');
		case 'tier3:discussions':
			return import(/* webpackChunkName: "icon-discussions" */'./tier3/discussions.js');
		case 'tier3:download':
			return import(/* webpackChunkName: "icon-download" */'./tier3/download.js');
		case 'tier3:email-open':
			return import(/* webpackChunkName: "icon-email-open" */'./tier3/email-open.js');
		case 'tier3:email':
			return import(/* webpackChunkName: "icon-email" */'./tier3/email.js');
		case 'tier3:evaluate-all':
			return import(/* webpackChunkName: "icon-evaluate-all" */'./tier3/evaluate-all.js');
		case 'tier3:export':
			return import(/* webpackChunkName: "icon-export" */'./tier3/export.js');
		case 'tier3:external':
			return import(/* webpackChunkName: "icon-external" */'./tier3/external.js');
		case 'tier3:feed':
			return import(/* webpackChunkName: "icon-feed" */'./tier3/feed.js');
		case 'tier3:file-audio':
			return import(/* webpackChunkName: "icon-file-audio" */'./tier3/file-audio.js');
		case 'tier3:file-document':
			return import(/* webpackChunkName: "icon-file-document" */'./tier3/file-document.js');
		case 'tier3:file-presentation':
			return import(/* webpackChunkName: "icon-file-presentation" */'./tier3/file-presentation.js');
		case 'tier3:file-video':
			return import(/* webpackChunkName: "icon-file-video" */'./tier3/file-video.js');
		case 'tier3:game':
			return import(/* webpackChunkName: "icon-game" */'./tier3/game.js');
		case 'tier3:gear':
			return import(/* webpackChunkName: "icon-gear" */'./tier3/gear.js');
		case 'tier3:google-drive':
			return import(/* webpackChunkName: "icon-google-drive" */'./tier3/google-drive.js');
		case 'tier3:grade':
			return import(/* webpackChunkName: "icon-grade" */'./tier3/grade.js');
		case 'tier3:help':
			return import(/* webpackChunkName: "icon-help" */'./tier3/help.js');
		case 'tier3:home':
			return import(/* webpackChunkName: "icon-home" */'./tier3/home.js');
		case 'tier3:image':
			return import(/* webpackChunkName: "icon-image" */'./tier3/image.js');
		case 'tier3:import':
			return import(/* webpackChunkName: "icon-import" */'./tier3/import.js');
		case 'tier3:lock-unlocked':
			return import(/* webpackChunkName: "icon-lock-unlocked" */'./tier3/lock-unlocked.js');
		case 'tier3:lock':
			return import(/* webpackChunkName: "icon-lock" */'./tier3/lock.js');
		case 'tier3:menu-hamburger':
			return import(/* webpackChunkName: "icon-menu-hamburger" */'./tier3/menu-hamburger.js');
		case 'tier3:menu':
			return import(/* webpackChunkName: "icon-menu" */'./tier3/menu.js');
		case 'tier3:news':
			return import(/* webpackChunkName: "icon-news" */'./tier3/news.js');
		case 'tier3:notification-bell':
			return import(/* webpackChunkName: "icon-notification-bell" */'./tier3/notification-bell.js');
		case 'tier3:pause-borderless':
			return import(/* webpackChunkName: "icon-pause-borderless" */'./tier3/pause-borderless.js');
		case 'tier3:pause':
			return import(/* webpackChunkName: "icon-pause" */'./tier3/pause.js');
		case 'tier3:pic':
			return import(/* webpackChunkName: "icon-pic" */'./tier3/pic.js');
		case 'tier3:play-borderless':
			return import(/* webpackChunkName: "icon-play-borderless" */'./tier3/play-borderless.js');
		case 'tier3:play':
			return import(/* webpackChunkName: "icon-play" */'./tier3/play.js');
		case 'tier3:preview':
			return import(/* webpackChunkName: "icon-preview" */'./tier3/preview.js');
		case 'tier3:profile-default':
			return import(/* webpackChunkName: "icon-profile-default" */'./tier3/profile-default.js');
		case 'tier3:profile-pic':
			return import(/* webpackChunkName: "icon-profile-pic" */'./tier3/profile-pic.js');
		case 'tier3:publish-all':
			return import(/* webpackChunkName: "icon-publish-all" */'./tier3/publish-all.js');
		case 'tier3:quizzing':
			return import(/* webpackChunkName: "icon-quizzing" */'./tier3/quizzing.js');
		case 'tier3:rubric-graded':
			return import(/* webpackChunkName: "icon-rubric-graded" */'./tier3/rubric-graded.js');
		case 'tier3:rubric':
			return import(/* webpackChunkName: "icon-rubric" */'./tier3/rubric.js');
		case 'tier3:scorm':
			return import(/* webpackChunkName: "icon-scorm" */'./tier3/scorm.js');
		case 'tier3:search':
			return import(/* webpackChunkName: "icon-search" */'./tier3/search.js');
		case 'tier3:stop-borderless':
			return import(/* webpackChunkName: "icon-stop-borderless" */'./tier3/stop-borderless.js');
		case 'tier3:stop':
			return import(/* webpackChunkName: "icon-stop" */'./tier3/stop.js');
		case 'tier3:syllabus':
			return import(/* webpackChunkName: "icon-syllabus" */'./tier3/syllabus.js');
		case 'tier3:upload':
			return import(/* webpackChunkName: "icon-upload" */'./tier3/upload.js');
		case 'tier3:view-submission-list':
			return import(/* webpackChunkName: "icon-view-submission-list" */'./tier3/view-submission-list.js');
	}
	return undefined;
}
